import AutoContributorLinkHandler from './AutoContributorLinkHandler';

export default AutoContributorLinkHandler;
